module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/05_shape-lg-6735a1c0a40d10831a01e9c5da36167f.png";